// ─────────────────────────────────────────────
//  Splash — public landing page at jiffyreview.com
// ─────────────────────────────────────────────
import Nav    from "../components/Nav";
import MiniQR from "../components/MiniQR";

export default function Splash({ goHow, goPricing, goOnboard }) {
  return (
    <div style={{ minHeight:"100vh", background:"#0a0a0f", fontFamily:"'Plus Jakarta Sans', sans-serif", color:"#f0ede8" }}>

      <Nav onHome={() => {}} onHow={goHow} onPricing={goPricing} onGetStarted={goOnboard} />

      {/* Hero */}
      <div style={{ maxWidth:1000, margin:"0 auto", padding:"90px 40px 70px", textAlign:"center" }}>
        <div style={{ display:"inline-flex", alignItems:"center", gap:8, background:"rgba(255,107,53,0.12)", border:"1px solid rgba(255,107,53,0.25)", borderRadius:20, padding:"6px 14px", marginBottom:32 }}>
          <span style={{ fontSize:13 }}>⚡</span>
          <span style={{ fontSize:12, fontWeight:700, color:"#FF6B35", letterSpacing:"0.05em" }}>NEW — QR reviews in 20 seconds</span>
        </div>

        <h1 style={{ fontSize:"clamp(38px,6vw,72px)", fontWeight:900, letterSpacing:"-0.04em", lineHeight:1.05, margin:"0 0 24px" }}>
          More reviews.<br />
          <span style={{ background:"linear-gradient(135deg,#FF6B35,#FFBE0B)", WebkitBackgroundClip:"text", WebkitTextFillColor:"transparent" }}>
            Zero friction.
          </span>
        </h1>

        <p style={{ fontSize:"clamp(16px,2.5vw,20px)", color:"rgba(255,255,255,0.5)", maxWidth:560, margin:"0 auto 44px", lineHeight:1.7, fontWeight:300 }}>
          Print a QR code on your receipt. Customers scan it, tap a few stars, and their review is live on Google, Yelp, and TripAdvisor — all in 20 seconds.
        </p>

        <div style={{ display:"flex", gap:12, justifyContent:"center", flexWrap:"wrap", marginBottom:70 }}>
          <button onClick={goOnboard} style={{ padding:"16px 32px", borderRadius:14, border:"none", background:"linear-gradient(135deg,#FF6B35,#FFBE0B)", color:"white", fontSize:16, fontWeight:800, cursor:"pointer", fontFamily:"inherit", letterSpacing:"-0.02em" }}>
            Get your QR code free →
          </button>
          <button onClick={goHow} style={{ padding:"16px 28px", borderRadius:14, border:"1.5px solid rgba(255,255,255,0.12)", background:"transparent", color:"rgba(255,255,255,0.6)", fontSize:16, fontWeight:600, cursor:"pointer", fontFamily:"inherit" }}>
            See how it works
          </button>
        </div>

        {/* Receipt hero visual */}
        <div style={{ position:"relative", maxWidth:680, margin:"0 auto" }}>
          <div style={{ background:"white", borderRadius:20, padding:"28px 24px", maxWidth:280, margin:"0 auto", boxShadow:"0 40px 80px rgba(0,0,0,0.5)", position:"relative", zIndex:2 }}>
            <div style={{ textAlign:"center", borderBottom:"1px dashed #e0e0e0", paddingBottom:16, marginBottom:16 }}>
              <div style={{ fontFamily:"monospace", fontSize:13, fontWeight:700, color:"#333" }}>THE RUSTIC TABLE</div>
              <div style={{ fontFamily:"monospace", fontSize:10, color:"#aaa", marginTop:4 }}>Austin, TX · Table 7</div>
              <div style={{ fontFamily:"monospace", fontSize:10, color:"#aaa" }}>Mar 9, 2026 · 7:42 PM</div>
            </div>
            <div style={{ fontFamily:"monospace", fontSize:11, color:"#555", marginBottom:16 }}>
              {[["Bruschetta","$12"],["Pasta Carbonara","$22"],["Tiramisu","$9"],["House Red (glass)","$14"]].map(([item,price]) => (
                <div key={item} style={{ display:"flex", justifyContent:"space-between", marginBottom:5 }}>
                  <span>{item}</span><span>{price}</span>
                </div>
              ))}
              <div style={{ borderTop:"1px solid #eee", paddingTop:8, marginTop:6, display:"flex", justifyContent:"space-between", fontWeight:700 }}>
                <span>TOTAL</span><span>$57.00</span>
              </div>
            </div>
            <div style={{ textAlign:"center", background:"#fafafa", borderRadius:12, padding:"14px 12px" }}>
              <div style={{ fontSize:10, color:"#888", marginBottom:8, fontWeight:600 }}>⚡ Enjoyed your meal?</div>
              <div style={{ display:"inline-block", padding:8, background:"white", borderRadius:8, border:"1px solid #f0ede8" }}>
                <MiniQR size={90} />
              </div>
              <div style={{ fontSize:9, color:"#bbb", marginTop:6 }}>Scan to leave a review · takes 20 sec</div>
            </div>
          </div>

          {/* Floating badges */}
          <div style={{ position:"absolute", top:20, right:-10, background:"white", borderRadius:14, padding:"12px 14px", boxShadow:"0 8px 24px rgba(0,0,0,0.3)", zIndex:3 }}>
            <div style={{ fontSize:11, fontWeight:700, color:"#4285F4", marginBottom:3 }}>Google ★★★★★</div>
            <div style={{ fontSize:11, color:"#555" }}>"Absolutely amazing!"</div>
            <div style={{ fontSize:9, color:"#aaa", marginTop:2 }}>2 min ago</div>
          </div>
          <div style={{ position:"absolute", bottom:30, left:-10, background:"white", borderRadius:14, padding:"12px 14px", boxShadow:"0 8px 24px rgba(0,0,0,0.3)", zIndex:3 }}>
            <div style={{ fontSize:11, fontWeight:700, color:"#D32323", marginBottom:3 }}>Yelp ★★★★★</div>
            <div style={{ fontSize:11, color:"#555" }}>"Best pasta in the city"</div>
            <div style={{ fontSize:9, color:"#aaa", marginTop:2 }}>Just posted</div>
          </div>

          {/* Glow */}
          <div style={{ position:"absolute", bottom:-60, left:"50%", transform:"translateX(-50%)", width:400, height:200, background:"radial-gradient(ellipse,rgba(255,107,53,0.2),transparent 70%)", zIndex:1, pointerEvents:"none" }} />
        </div>
      </div>

      {/* Social proof bar */}
      <div style={{ borderTop:"1px solid rgba(255,255,255,0.07)", borderBottom:"1px solid rgba(255,255,255,0.07)", padding:"28px 40px", background:"rgba(255,255,255,0.02)" }}>
        <div style={{ maxWidth:900, margin:"0 auto", display:"flex", justifyContent:"space-around", flexWrap:"wrap", gap:24 }}>
          {[["2,400+","businesses using JiffyReview"],["47,000+","reviews collected"],["4.8★","average merchant rating"],["20 sec","average review time"]].map(([val, label]) => (
            <div key={label} style={{ textAlign:"center" }}>
              <div style={{ fontSize:28, fontWeight:900, color:"#FF6B35", letterSpacing:"-0.03em" }}>{val}</div>
              <div style={{ fontSize:12, color:"rgba(255,255,255,0.35)", marginTop:3 }}>{label}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Features grid */}
      <div style={{ maxWidth:960, margin:"0 auto", padding:"80px 40px" }}>
        <div style={{ textAlign:"center", marginBottom:56 }}>
          <div style={{ fontSize:11, color:"#FF6B35", fontWeight:700, letterSpacing:"0.12em", marginBottom:12 }}>WHY BUSINESSES LOVE IT</div>
          <h2 style={{ fontSize:"clamp(28px,4vw,44px)", fontWeight:900, letterSpacing:"-0.03em", margin:0 }}>
            Everything you need.<br />Nothing you don't.
          </h2>
        </div>
        <div style={{ display:"grid", gridTemplateColumns:"repeat(3,1fr)", gap:20 }}>
          {[
            { icon:"📱", title:"QR on every receipt", desc:"One QR code. Works on thermal printers, table tents, and stickers. Customers scan without downloading anything." },
            { icon:"⚡", title:"20-second reviews", desc:"Business name, location, and date are pre-filled. Customers tap stars, choose platforms, done. Lowest friction possible." },
            { icon:"🔒", title:"Review gating", desc:"1-2 star reviews go privately to you first. You fix the issue before it goes public. Protect your reputation automatically." },
            { icon:"📊", title:"All platforms, one place", desc:"Google, Yelp, TripAdvisor, Facebook. See every review in one dashboard. Reply without switching tabs." },
            { icon:"🎁", title:"Thank-you incentives", desc:"Automatically send a discount code after every review. Turn reviewers into repeat customers." },
            { icon:"🔔", title:"Instant alerts", desc:"Get an SMS the moment a low-star review comes in. Respond before they post on social media." },
          ].map(({ icon, title, desc }) => (
            <div key={title} style={{ background:"rgba(255,255,255,0.03)", border:"1px solid rgba(255,255,255,0.07)", borderRadius:16, padding:"24px 22px" }}>
              <div style={{ fontSize:32, marginBottom:14 }}>{icon}</div>
              <div style={{ fontSize:16, fontWeight:800, marginBottom:8, letterSpacing:"-0.02em" }}>{title}</div>
              <div style={{ fontSize:13, color:"rgba(255,255,255,0.45)", lineHeight:1.7, fontWeight:300 }}>{desc}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Bottom CTA */}
      <div style={{ background:"linear-gradient(135deg,rgba(255,107,53,0.15),rgba(255,190,11,0.1))", borderTop:"1px solid rgba(255,107,53,0.2)", borderBottom:"1px solid rgba(255,107,53,0.2)", padding:"70px 40px", textAlign:"center" }}>
        <h2 style={{ fontSize:"clamp(24px,4vw,42px)", fontWeight:900, letterSpacing:"-0.03em", margin:"0 0 16px" }}>Ready to get more reviews?</h2>
        <p style={{ color:"rgba(255,255,255,0.4)", marginBottom:32, fontSize:16, fontWeight:300 }}>Set up in 5 minutes. First 30 days free. No credit card needed.</p>
        <button onClick={goOnboard} style={{ padding:"18px 40px", borderRadius:14, border:"none", background:"linear-gradient(135deg,#FF6B35,#FFBE0B)", color:"white", fontSize:17, fontWeight:800, cursor:"pointer", fontFamily:"inherit", letterSpacing:"-0.02em" }}>
          Start free — get your QR code →
        </button>
      </div>

      <div style={{ textAlign:"center", padding:24, fontSize:12, color:"rgba(255,255,255,0.2)" }}>
        © 2026 JiffyReview.com · <span style={{ cursor:"pointer" }}>Privacy</span> · <span style={{ cursor:"pointer" }}>Terms</span>
      </div>
    </div>
  );
}
